import React from 'react';
import { inject, observer, disposeOnUnmount } from 'mobx-react';
import c from 'classnames';
import Draggable from '@lyearn-team/frontend-components/dist/Draggable';
import { reaction } from 'mobx';
import ActivityChat from '../ActivityChat';
import * as s from './styles';

@inject(stores => ({ model: stores.liveClassModel }))
@observer
class ActivityPopup extends React.Component {
  constructor(props) {
    super(props);

    this.popupRef = React.createRef();

    disposeOnUnmount(this, [
      reaction(
        () => {
          const { store } = this.props.model;
          return store.activity.isPopupVisible;
        },
        this.handlePopupAnimation,
        {
          fireImmediately: true
        }
      )
    ]);
  }

  handlePopupAnimation = (isVisible) => {
    const popup = this.popupRef.current;
    if (!popup) {
      return;
    }
    if (isVisible) {
      setTimeout(() => {
        if (popup) {
          popup.classList.add('no-transition');
        }
      }, 600);
    } else {
      popup.style = '';
      popup.classList.remove('no-transition');
    }
  };

  renderActivityChat = () => {
    const { model } = this.props;
    const { activity } = model.store;
    const { isPopupVisible } = activity;
    if (!isPopupVisible) {
      return null;
    }

    return <ActivityChat />;
  };

  render() {
    const { model } = this.props;
    const { activity, isMobile } = model.store;
    const { isPopupVisible } = activity;

    if (isMobile) {
      return null;
    }

    return (
      <Draggable>
        <div
          className={c(s.root, { visible: isPopupVisible, invisible: !isPopupVisible })}
          ref={this.popupRef}
        >
          {this.renderActivityChat()}
        </div>
      </Draggable>
    );
  }
}

export default ActivityPopup;
